export default class Utils {

  static dateToString(date) {
    return this.dateToCompactString(date) + 'T23:59:00.000Z';
  }

  static dateToCompactString(date) {
    const ddigits = (n) => n < 10 ? '0' + n : n;
    return `${date.getFullYear()}-${ddigits(date.getMonth() + 1)}-${ddigits(date.getDate())}`;
  }

  static getSafely(obj, names) {
    for (let name of names.split('.')) {
      if (!obj) {
        return undefined;
      }
      obj = obj[name];
    }
    return obj;
  }

  static setSafely(obj, path, value) {
    let node = obj;
    let tokens = path.split('.');
    let lastToken = tokens.pop();
    for (let name of tokens) {
      if (!node[name]) {
        node[name] = {};
      }
      node = node[name];
    }
    node[lastToken] = value;
    
  }

  static deleteSafely(obj, path ){
    console.log("deleteSafely: ",obj,path);
    let node = obj;
    let tokens = path.split('.');
    let lastToken = tokens.pop();
    for (let name of tokens) {
      if (!node[name]) {
        node[name] = {};
      }
      node = node[name];
    }
    delete node[lastToken];
  }

  static getEventXY(event, element) {
    let xy = {
      x: event.clientX,
      y: event.clientY
    };
    if (element) {
      let offset = element.getBoundingClientRect();
      xy.x -= offset.left;
      xy.y -= offset.top;
    }
    return xy;
  }

  static findFirstObject(array, iterator) {
    let returnedObj;
    let obj = array.find((n) => {
      let x = iterator(n);
      if (typeof x === 'object') {
        returnedObj = x;
      }
      return x;
    });
    return returnedObj || obj;
  }

  static angleBetweenLines(v1x1, v1y1, v1x2, v1y2, v2x1, v2y1, v2x2, v2y2) {
    let angle1 = Math.atan2(v1y1 - v1y2, v1x1 - v1x2);
    let angle2 = Math.atan2(v2y1 - v2y2, v2x1 - v2x2);
    let angle = (angle1 - angle2) * 180 / Math.PI;
    return angle;
  }

  static adjustBetweenValues(value, min, max) {
    const range = max - min;
    while (value < min) {
      value += range;
    }
    while (value > max) {
      value -= range;
    }
    return value;
  }

  static toFixed(value, decimals) {
    return parseFloat(value.toFixed(decimals));
  }

  static createCanvasImage(url) {
    return new Promise((resolve) => {
      let image = new Image();
      image.src = url;
      image.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        let ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);
        resolve(canvas);
      }
    });
  }

  static convertBoolsToInts(value) {
    if (Array.isArray(value)) {
      return value.map(x => this.convertBoolsToInts(x));
    } else if (typeof value === 'object') {
      var newValue = {};
      for (let key in value) {
        newValue[key] = this.convertBoolsToInts(value[key]);
      }
      return newValue;
    } else if (typeof value === 'boolean') {
      return value ? 1 : 0;
    }
    return value;
  }

  static compareSetValueToAlgorithm(setValue, algo) {
    let algoRes = algo;
    let setValArr = setValue.replace(/[^0-9]/g, '').split('');
    setValArr = setValArr.map(val => parseInt(val));
    let resArr;
    if (setValArr.length > algoRes.length) {
      resArr = Array(setValArr.length);
      let pad = Array(setValArr.length - algoRes.length);
      pad.fill(null);
      algoRes = pad.concat(algoRes);
    } else if (setValArr.length < algoRes.length) {
      resArr = Array(algoRes.length);
      let pad = Array(algoRes.length - setValArr.length);
      pad.fill(0);
      setValArr = pad.concat(setValArr);
    } else {
      resArr = Array(algoRes.length);
    }
    resArr.fill(null);
    for (let i = 0; i < resArr.length; i += 1) {
      if (setValArr[i] !== null && algoRes[i] !== null) {
        resArr[i] = (algoRes[i] > -1 && algoRes[i] !== setValArr[i]) ? false : true;
      }
    }
    let result = resArr.find(val => val !== true) === undefined;
    if (result) {
      result = algoRes.find(val => val === null || val > -1) !== undefined;
    }
    return { algorithm: algoRes, setValue: setValArr, comparison: resArr, result };
  }
}



// WEBPACK FOOTER //
// ./client/utils/index.js